
import React from "react";
import App from './App';
import ReactDOM from "react-dom";

window.AppComponent = App;
window.React = React;
window.ReactDOM = ReactDOM;
